export var UrlParamTypes;
(function (UrlParamTypes) {
    UrlParamTypes["TOKEN"] = "token";
    UrlParamTypes["RESET_TOKEN"] = "resetToken";
    UrlParamTypes["TARGET"] = "target";
    UrlParamTypes["HIDE_FA_MODULE"] = "hideFaModule";
    UrlParamTypes["SOURCE"] = "source";
    UrlParamTypes["POSTCODE"] = "postcode";
    UrlParamTypes["CAR_CODE"] = "carCode";
    UrlParamTypes["MARKETING_CATEGORY"] = "marketingCategory";
    UrlParamTypes["SPECIFICATION_PACK"] = "specificationPack";
    UrlParamTypes["SELECTED_FEATURES"] = "selectedFeatures";
    UrlParamTypes["VARIANT_ID"] = "variantId";
    UrlParamTypes["ENGINE"] = "engine";
    UrlParamTypes["MODEL"] = "model";
    UrlParamTypes["TRANSMISSION_TYPE"] = "transmissionType";
    UrlParamTypes["BODY_STYLE_TYPE"] = "bodyStyleType";
    UrlParamTypes["FUEL_TYPE"] = "fuelType";
    UrlParamTypes["PRICE"] = "price";
    UrlParamTypes["SERIES_TYPE"] = "seriesType";
    UrlParamTypes["BODY_TYPE"] = "bodytypeType";
    UrlParamTypes["GROSS_WEIGHT_CAPACITY_TYPE"] = "grossWeightCapacityType";
    UrlParamTypes["MAXIMUM_POWER_TYPE"] = "maximumPowerType";
    UrlParamTypes["USABLE_CAB_TO_AXLE_TYPE"] = "usableCabToAxleType";
    UrlParamTypes["VEHICLE_GROSS_WEIGHT_TYPE"] = "vehicleGrossWeightType";
    UrlParamTypes["DIMENSIONS_FROM_WHEEL_TRACK_TYPE"] = "dimensionsFromWheelTrackType";
    UrlParamTypes["DIVISION"] = "division";
    UrlParamTypes["REVERT_TO_BYO"] = "revertToByo";
    UrlParamTypes["NO_MODAL"] = "noModal";
    UrlParamTypes["PAYMENT_ID"] = "paymentId";
    UrlParamTypes["OPEN_FC"] = "openFc";
    UrlParamTypes["TRIM_CODE"] = "trimCode";
    UrlParamTypes["MODEL_CODE"] = "modelCode";
    UrlParamTypes["EXTERIOR"] = "exterior";
    UrlParamTypes["ROOF"] = "roof";
    UrlParamTypes["INTERIOR"] = "interior";
    UrlParamTypes["BACKGROUND"] = "background";
    UrlParamTypes["ACCESSORIES"] = "accessories";
    UrlParamTypes["STEPSTAKEN"] = "stepsTaken";
    UrlParamTypes["EXPRESSIONS_OF_INTEREST"] = "expressionsOfInterest";
    UrlParamTypes["FROM"] = "from";
    UrlParamTypes["DXP_PREVIEW"] = "dxp-preview";
    UrlParamTypes["PUBLIC_TOKEN"] = "publicTokenPerDealer";
    UrlParamTypes["ADDONS"] = "Add-ons";
    UrlParamTypes["VALIDATE_FAPP_STATUS"] = "validateFappStatus";
})(UrlParamTypes || (UrlParamTypes = {}));
//# sourceMappingURL=UrlParamTypes.js.map